/**
 * Paint Request API (Phase C).
 *
 * Endpoint shipped in Phase B (commit 2ac2ea7); list action added in Phase C.
 * All routes return 404 when paint_service_enabled is OFF — callers must
 * catch that 404 silently so the UI stays inert until the operator flips
 * the flag in Phase F.
 */
import client from './client';

export async function createPaintRequest(payload) {
  // payload: { job_bom_line_id, qty_sent, paint_color, special_instructions }
  // Returns PaintRequestReadSerializer shape, includes paint_request_number.
  const { data } = await client.post('/purchasing/paint-requests/', payload);
  return data;
}

export async function fetchPaintRequestsForJob(jobId) {
  // Returns [] when the flag is ON and the job has no batches.
  // Throws on 404 (flag OFF) — caller is responsible for swallowing it.
  const { data } = await client.get('/purchasing/paint-requests/', {
    params: { job: jobId },
  });
  return data || [];
}
